<template>
  <div class="bet-odds-summary">
    <div class="odd-row" v-for="odd in getBet.odds" :key="$uuid.v1()">
      <div class="outcome">
        <span class="outcome_name">
          {{ odd.outcome_name }} {{ getSpread(odd.market_unique_id) }}
          <span class="choice" v-if="odd.changed">
            <v-icon
              color="success"
              dense
              @click="acceptOddVariation(odd.unique_id)"
              >mdi-checkbox-marked</v-icon
            >
            <v-icon color="red" dense @click="removeOdd(odd.unique_id)"
              >mdi-close-box</v-icon
            >
          </span>
          <span class="choice" v-if="odd.to_remove">
            <v-icon color="red" dense @click="removeOdd(odd.unique_id)"
              >mdi-close-box</v-icon
            >
          </span>
        </span>
        <span class="market_name">{{ odd.market_name }}</span>
      </div>
      <div class="odd-value-box">
        <div
          :class="[
            'value',
            odd.type_change != undefined ? odd.type_change : 'equal',
          ]"
        >
          {{ odd.outcome_odd_value | odds_type_filter }}
        </div>
      </div>

      <div class="trash">
        <v-icon dense @click="removeOdd(odd.unique_id)">mdi-delete</v-icon>
        <!--          <div v-if="getBet.type == 'system'">-->
        <!--            <div :class="['base',(checkFixedBase(odd.unique_id))? 'fixed' : '']" @click="addFixedBase(odd.unique_id)">B</div>-->
        <!--          </div>-->
      </div>
      <div class="additional-info-cart">
        <span class="event_description" :title="odd.event_description">{{
          odd.event_description | truncate(38)
        }}</span>
      </div>
      <div class="cart-base" v-if="getBet.type == 'system'">
        <div
          :class="['base', checkFixedBase(odd.unique_id) ? 'fixed' : '']"
          @click="addFixedBase(odd.unique_id)"
        >
          B
        </div>
      </div>
      <div class="event-date" v-if="odd.time > 0">
        <span
          v-if="
            getUserType == 4 ||
            getCashier ||
            !getSettings.enableQuickBetOnlyForAgency
          "
          class="quickbet-cart"
          >{{ odd.quickbet }}</span
        >
        <span class="label-live" v-if="odd.type == 'live'">{{
          $t('live')
        }}</span>
        <span class="date" v-else>{{ getTime(odd.time) }}</span>
      </div>
      <div
        class="odd-not-available"
        v-if="
          odd.type == 'prematch' &&
          odd.time < new Date().getTime() &&
          !odd.to_remove
        "
      >
        <span class="text-error">{{ $t('oddNotAvailable') }}</span>
      </div>
      <div class="odd-not-available" v-if="odd.to_remove">
        <span class="text-error">{{ $t('oddNotAvailable') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BetOddsSummary',
  data: () => ({}),
  mounted() {
    this.$store.commit('cart/SET_SYSTEM_FIXED_BASES', [])
    this.$root.$on('forceUpdateOddsSummary', () => {
      this.forceUpdateOddsSummary()
    })
  },
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
    }),
  },
  methods: {
    ...mapActions({
      removeOddFromCart: 'cart/removeOddFromCart',
      refreshCart: 'cart/refreshCart',
      checkFixedBaseSystem: 'cart/checkFixedBaseSystem',
      acceptOdd: 'cart/acceptOdd',
    }),

    async acceptOddVariation(outcomeUniqueId) {
      await this.acceptOdd({ unique_id: outcomeUniqueId })
      this.forceUpdateOddsSummary()
      await this.refreshCart()
      this.$root.$emit('forceUpdateSystem')
      this.$root.$emit('forceUpdateSingleMultiple')
      this.$root.$emit('forceUpdateIntegral')
    },

    async removeOdd(outcomeUniqueId) {
      await this.removeOddFromCart({ unique_id: outcomeUniqueId })
      await this.checkFixedBaseSystem({ unique_id: outcomeUniqueId })
      this.$root.$emit('forceUpdateSystem')
      this.$root.$emit('forceUpdateSingleMultiple')
      this.$root.$emit('forceUpdateIntegral')
    },

    async addFixedBase(outcomeUniqueId) {
      await this.checkFixedBaseSystem({ unique_id: outcomeUniqueId })
      this.$root.$emit('forceUpdateSystem')
    },

    checkFixedBase(outcomeUniqueId) {
      return this.getBet._system_detail.fixed_bases.includes(outcomeUniqueId)
    },

    forceUpdateOddsSummary() {
      this.$forceUpdate()
    },

    getSpread(spec) {
      let result = ''

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },

    getTime(dateTimeMillis) {
      const date = new Date(dateTimeMillis)
      const time = new Date(dateTimeMillis).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })
      return time + ' - ' + date.toLocaleDateString()
    },
  },
}
</script>
